import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Button, Card, Icon, LoadingSpinner } from "pepsico-ds";
import React, { useState } from "react";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import { snowFields, ticketDetails } from "../../../utils/fieldConstants";
import parse from "html-react-parser";
import {
  formatProjectDate,
  formatSubmittedDateTime,
} from "../../../utils/dateFormat";
type ViewSnowActivityProps = {
  open: boolean;
  onclose: () => void;
};
const ViewSnowActivity = ({ open, onclose }: ViewSnowActivityProps) => {
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
  const { snowActivity, RITMActivity, pending } = useSelector(
    (state: RootState) => state.engagementData
  );
  const convertedData = (data: any) => {
    const formattedData = data.replace(/\n/g, "<br />");
    return parse(formattedData);
  };
  return (
    <Dialog
      open={open}
      onClose={onclose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          width: "53%",
          height: "100%",
          maxHeight: "100%",
          position: "absolute",
          right: 0,
          top: 0,
          margin: 0,
        },
      }}
    >
      <DialogTitle
        sx={{ padding: "10px 24px", backgroundColor: "#eff5fc" }}
        id="scroll-dialog-title"
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
            onClick={onclose}
          >
            <Icon
              alt="alt value"
              className="$color-icon-default"
              icon="clear"
              size="large"
            />
          </div>
          <div>
            <Typography
              sx={{
                alignSelf: "center",
                fontFamily: '"Inter", sans-serif',
                fontSize: "20px",
                fontWeight: "700",
              }}
              variant="h6"
              gutterBottom
            >
              MyServices Consulting Intake Request Details
            </Typography>
          </div>
        </div>
      </DialogTitle>

      <DialogContent dividers={scroll === "paper"} sx={{ marginLeft: "25px" }}>
        <DialogContentText
          id="scroll-dialog-description"
          tabIndex={-1}
        ></DialogContentText>
        {pending ? (
          <div
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <LoadingSpinner
              fullscreen={false}
              size={{ height: "50px", width: "50px" }}
            />
          </div>
        ) : (
          <>
            {snowActivity.length && (
              <div style={{ margin: "5px" }} className="RITM-Activity">
                <div className="Activity-view">
                  <Card border ellipsis={false} icon=" ">
                    <div
                      className="$font-body-bold $color-text-primary"
                      style={{ marginTop: "5px" }}
                    >
                      Ticket Details
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "16px",
                      }}
                    >
                      {ticketDetails.map(({ label, key, formatter }) => (
                        <div key={key} style={{ flex: "1 1 45%" }}>
                          <div
                            className="$font-small-regular"
                            style={{ color: "grey" }}
                          >
                            {label}
                          </div>
                          <div
                            className="$font-small-regular"
                            style={{ marginTop: "3px" }}
                          >
                            {formatter
                              ? formatter(snowActivity[0]?.[key])
                              : snowActivity[0]?.[key]
                              ? snowActivity[0]?.[key]
                              : "N/A"}
                          </div>
                        </div>
                      ))}
                    </div>
                    <hr
                      style={{
                        border: "0.1px dashed #d7e5f8",
                        width: "100%",
                      }}
                    />
                    <div
                      className="$font-body-bold $color-text-primary"
                      style={{ marginTop: "5px" }}
                    >
                      Form Details
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "16px",
                      }}
                    >
                      {snowFields.map(({ label, key, formatter, convert }) => (
                        <div key={key} style={{ flex: "1 1 45%" }}>
                          <div
                            className="$font-small-regular"
                            style={{ color: "grey" }}
                          >
                            {label}
                          </div>
                          <div
                            className="$font-small-regular"
                            style={{ marginTop: "3px" }}
                          >
                            {formatter
                              ? formatter(snowActivity[0]?.[key])
                              : convert
                              ? convertedData(snowActivity[0]?.[key])
                              : snowActivity[0]?.[key]
                              ? snowActivity[0]?.[key]
                              : "N/A"}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card>
                </div>
              </div>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}></div>
          <Button
            size="medium"
            text="Close"
            variant="secondary"
            onClick={onclose}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ViewSnowActivity;
